// // import React, { useEffect, useState } from "react";
// // import DateRangePicker from "react-daterange-picker";
// // import "react-daterange-picker/dist/css/react-calendar.css";

// // import originalMoment from "moment";
// // import { extendMoment } from "moment-range";
// // import { useDispatch } from "react-redux";
// // import { setTimeSeries } from "../../../redux/features/dashboardSlice";

// // const moment = extendMoment(originalMoment);
// // const today = moment();
// // const stateDefinitions = {
// //   unavailable: {
// //     selectable: false,
// //     color: "#78818b",
// //     label: "Unavailable",
// //   },
// // };
// // const dateRanges = [
// //   {
// //     state: "unavailable",
// //     range: moment.range(today.clone().subtract(4, "days"), today.clone()),
// //   },
// // ];
// // export default function DateRangePickerr(props) {
// //   const today = moment();
// //   const dispatch = useDispatch();

// //   const [states, setStates] = useState({
// //     value: moment.range(today.clone().subtract(4, "days"), today.clone()),
// //     dateRanges: [
// //       {
// //         state: "enquire",
// //         range: moment.range(
// //           moment().add(2, "weeks").subtract(5, "days"),
// //           moment().add(2, "weeks").add(6, "days")
// //         ),
// //       },
// //       {
// //         state: "unavailable",
// //         range: moment.range(
// //           moment().add(3, "weeks"),
// //           moment().add(3, "weeks").add(5, "days")
// //         ),
// //       },
// //     ],
// //   });

// //   const onSelect = (value, states) => {
// //     setStates({ value, states });
// //   };

// //   useEffect(() => {
// //     dispatch(
// //       setTimeSeries({
// //         start: states.value.start.format("DD-MM-YYYY"),
// //         end: states.value.end.format("DD-MM-YYYY"),
// //       })
// //     );
// //   }, [states]);

// //   return (
// //     <>
// //       <DateRangePicker
// //         months={2}
// //         value={states.value}
// //         // stateDefinitions={stateDefinitions}
// //         // dateStates={dateRanges}
// //         onSelect={onSelect}
// //         maximumDate={moment().add(1, "months").calendar()}
// //         minimumDate={moment().subtract(1, "months").calendar()}
// //         singleDateRange={true}
// //         numberOfCalendars={2}
// //         showLegend={true}
// //         rangeColors={["#f33e5b", "#3ecf8e", "#fed14c"]}
// //       />
// //     </>
// //   );
// // }

// import { addDays } from "date-fns";
// import { useEffect, useState } from "react";
// import { DateRangePicker } from "react-date-range";
// import "react-date-range/dist/styles.css";
// import "react-date-range/dist/theme/default.css";
// import { useDispatch } from "react-redux";
// import { setTimeSeries } from "../../../redux/features/dashboardSlice";
// import moment from "moment";
// export default function DateRangePickerr(maxDate) {
//   const dispatch = useDispatch();
//   const [state, setState] = useState([
//     {
//       startDate: addDays(new Date(), -7),
//       endDate: new Date(),
//       key: "selection",
//     },
//   ]);

//   useEffect(() => {
//     dispatch(
//       setTimeSeries({
//         start: moment(state[0].startDate).format("DD-MM-YYYY"),
//         end: moment(state[0].endDate).format("DD-MM-YYYY"),
//       })
//       // setTimeSeries({
//       //   start: state[0].startDate,
//       //   end: state[0].endDate,
//       // })
//     );
//   }, [state]);

//   return (
//     <DateRangePicker
//       onChange={(item, val) => {
//         console.log({ item });
//         if (item.selection.endDate < new Date()) {
//           setState([item.selection]);
//         }
//       }}
//       maxDate={new Date()}
//       showSelectionPreview={true}
//       moveRangeOnFirstSelection={false}
//       months={2}
//       ranges={state}
//       direction="horizontal"
//     />
//   );
// }

// import React, { useEffect, useState } from "react";
// import DateRangePicker from "react-daterange-picker";
// import "react-daterange-picker/dist/css/react-calendar.css";

// import originalMoment from "moment";
// import { extendMoment } from "moment-range";
// import { useDispatch } from "react-redux";
// import { setTimeSeries } from "../../../redux/features/dashboardSlice";

// const moment = extendMoment(originalMoment);
// const today = moment();
// const stateDefinitions = {
//   unavailable: {
//     selectable: false,
//     color: "#78818b",
//     label: "Unavailable",
//   },
// };
// const dateRanges = [
//   {
//     state: "unavailable",
//     range: moment.range(today.clone().subtract(4, "days"), today.clone()),
//   },
// ];
// export default function DateRangePickerr(props) {
//   const today = moment();
//   const dispatch = useDispatch();

//   const [states, setStates] = useState({
//     value: moment.range(today.clone().subtract(4, "days"), today.clone()),
//     dateRanges: [
//       {
//         state: "enquire",
//         range: moment.range(
//           moment().add(2, "weeks").subtract(5, "days"),
//           moment().add(2, "weeks").add(6, "days")
//         ),
//       },
//       {
//         state: "unavailable",
//         range: moment.range(
//           moment().add(3, "weeks"),
//           moment().add(3, "weeks").add(5, "days")
//         ),
//       },
//     ],
//   });

//   const onSelect = (value, states) => {
//     setStates({ value, states });
//   };

//   useEffect(() => {
//     dispatch(
//       setTimeSeries({
//         start: states.value.start.format("DD-MM-YYYY"),
//         end: states.value.end.format("DD-MM-YYYY"),
//       })
//     );
//   }, [states]);

//   return (
//     <>
//       <DateRangePicker
//         months={2}
//         value={states.value}
//         // stateDefinitions={stateDefinitions}
//         // dateStates={dateRanges}
//         onSelect={onSelect}
//         maximumDate={moment().add(1, "months").calendar()}
//         minimumDate={moment().subtract(1, "months").calendar()}
//         singleDateRange={true}
//         numberOfCalendars={2}
//         showLegend={true}
//         rangeColors={["#f33e5b", "#3ecf8e", "#fed14c"]}
//       />
//     </>
//   );
// }

import { useEffect, useState } from "react";
import {
  DateRangePicker,
  defaultInputRanges,
  defaultStaticRanges,
} from "react-date-range";
import "react-date-range/dist/styles.css";
import "react-date-range/dist/theme/default.css";
import { useDispatch, useSelector } from "react-redux";
import {
  setButtonClicked,
  setTimeSeries,
  setTimeSeries1,
  setTimeSeriesDateType,
} from "../../../redux/features/dashboardSlice";
import moment from "moment";
import {
  addDays,
  endOfDay,
  startOfDay,
  startOfYear,
  startOfMonth,
  endOfMonth,
  endOfYear,
  addMonths,
  subMonths,
  addYears,
  startOfWeek,
  endOfWeek,
  isSameDay,
  differenceInCalendarDays,
} from "date-fns";
export default function DateRangePickerr({ reduxFunc }) {
  const resd = useSelector((data) => data?.dashboardReducer);

  // console.log({ resd });
  const dispatch = useDispatch();

  var date = new Date(),
    y = date.getFullYear(),
    m = date.getMonth();
  var firstDay = new Date(y, m, 1);
  const [state, setState] = useState([
    {
      startDate: new Date(resd?.timeSeries?.start),
      endDate: new Date(resd?.timeSeries?.end),
      key: "selection",
    },
  ]);

  // useEffect(() => {
  //   dispatch(
  //     setTimeSeries({
  //       start: moment(state[0].startDate).format("YYYY-MM-DD"),
  //       end: moment(state[0].endDate).format("YYYY-MM-DD"),
  //     })
  //   );
  // }, [state]);

  const onChangee = (item, val) => {
    if (
      item.selection.endDate > new Date() &&
      item.selection.startDate <
        new Date(moment(new Date()).subtract(6, "months"))
    ) {
      // console.log("payload if");
      setState([
        {
          startDate: new Date(moment(new Date()).subtract(6, "months")),
          endDate: new Date(),
          key: "selection",
        },
      ]);
      dispatch(setTimeSeriesDateType("Monthly"));
    } else if (item.selection.endDate > new Date()) {
      // console.log("payload if 1");
      var date = moment(new Date());
      var now = moment(item.selection.startDate);
      var duration = moment.duration(date.diff(now));
      var noofDays = duration.asDays();
      if (noofDays >= 30) dispatch(setTimeSeriesDateType("Monthly"));
      else dispatch(setTimeSeriesDateType("Daily"));
      setState([
        {
          startDate: item.selection.startDate,
          endDate: new Date(),
          key: "selection",
        },
      ]);
    } else if (
      item.selection.startDate <
      new Date(moment(new Date()).subtract(6, "months"))
    ) {
      // console.log("payload if 2");
      dispatch(setTimeSeriesDateType("Monthly"));
      setState([
        {
          startDate: new Date(moment(new Date()).subtract(6, "months")),
          endDate: item.selection.endDate,
          key: "selection",
        },
      ]);
    } else {
      var date = moment(item.selection.endDate);
      var now = moment(item.selection.startDate);
      var duration = moment.duration(date.diff(now));
      var noofDays = duration.asDays();
      // console.log(
      //   "payload else",
      //   { date, now, duration, noofDays },
      //   item.selection.startDate
      // );
      if (noofDays >= 30) dispatch(setTimeSeriesDateType("Monthly"));
      else dispatch(setTimeSeriesDateType("Daily"));
      setState([item.selection]);
    }
  };

  return (
    <>
      <DateRangePicker
        // onChange={(item, val) => {
        //   setState([item.selection]);
        // }}
        // onChange={(item, val) => {
        //   console.log({ item });
        //   if (
        //     item.selection.endDate < new Date() &&
        //     item.selection.endDate > firstDay
        //   ) {
        //     setState([item.selection]);
        //   }
        // }}

        // onChange={(item, val) => {
        //   console.log({ item });
        //   if (
        //     item.selection.endDate < new Date() &&
        //     item.selection.endDate > firstDay
        //   ) {
        //     setState([item.selection]);
        //   }
        // }}

        // onChange={(item, val) => {
        //   console.log({ item });
        //   if (
        //     item.selection.endDate < new Date() &&
        //     item.selection.endDate >
        //       new Date(
        //         moment(new Date()).subtract(6, "months").format("YYYY-MM-DD")
        //       )
        //   ) {
        //     setState([item.selection]);
        //   }
        // }}

        onChange={(item, val) => onChangee(item, val)}
        inputRanges={
          [
            // {
            //   ...defaultInputRanges[0],
            //   label: "Your new label",
            // },
          ]
        }
        staticRanges={[
          { ...defaultStaticRanges[0] },
          { ...defaultStaticRanges[1] },
          { ...defaultStaticRanges[2], label: "1 Week" },
          { ...defaultStaticRanges[4], label: "1 Month" },
          {
            label: "3 Months",
            range: () => ({
              startDate: startOfMonth(addMonths(new Date(), -3)),
              endDate: new Date(),
            }),
            isSelected(range) {
              const definedRange = this.range();
              return (
                isSameDay(range.startDate, definedRange.startDate) &&
                isSameDay(range.endDate, definedRange.endDate)
              );
            },
          },
          {
            label: "6 Months",
            range: () => ({
              startDate: startOfMonth(addMonths(new Date(), -6)),
              endDate: new Date(),
            }),
            isSelected(range) {
              const definedRange = this.range();
              return (
                isSameDay(range.startDate, definedRange.startDate) &&
                isSameDay(range.endDate, definedRange.endDate)
              );
            },
          },
          // {
          //   label: "1 Year",
          //   range: () => ({
          //     startDate: startOfMonth(addMonths(new Date(), -12)),
          //     endDate: endOfDay(new Date()),
          //   }),
          //   isSelected(range) {
          //     const definedRange = this.range();
          //     return (
          //       isSameDay(range.startDate, definedRange.startDate) &&
          //       isSameDay(range.endDate, definedRange.endDate)
          //     );
          //   },
          // },

          // {
          //   label: "last year",
          //   range: () => ({
          //     startDate: startOfYear(addYears(new Date(), -1)),
          //     endDate: endOfYear(addYears(new Date(), -1)),
          //   }),
          //   isSelected(range) {
          //     const definedRange = this.range();
          //     return (
          //       isSameDay(range.startDate, definedRange.startDate) &&
          //       isSameDay(range.endDate, definedRange.endDate)
          //     );
          //   },
          // },
          // {
          //   label: "this year",
          //   range: () => ({
          //     startDate: startOfYear(new Date()),
          //     endDate: endOfDay(new Date()),
          //   }),
          //   isSelected(range) {
          //     const definedRange = this.range();
          //     return (
          //       isSameDay(range.startDate, definedRange.startDate) &&
          //       isSameDay(range.endDate, definedRange.endDate)
          //     );
          //   },
          // },
        ]}
        maxDate={new Date()}
        minDate={new Date(moment(new Date()).subtract(6, "months"))}
        showSelectionPreview={true}
        moveRangeOnFirstSelection={false}
        months={2}
        ranges={state}
        direction="horizontal"
      />
      <div className="row my-3 px-3">
        <div className="text-end">
          <button
            type="button"
            onClick={() => {
              setState([
                {
                  startDate: new Date(moment(firstDay).format("YYYY-MM-DD")),
                  endDate: new Date(moment(new Date()).format("YYYY-MM-DD")),
                  key: "selection",
                },
              ]);
              dispatch(
                setTimeSeries({
                  end: moment(new Date()).format("YYYY-MM-DD"),
                  start: moment(firstDay).format("YYYY-MM-DD"),
                  dateType: resd?.timeSeries?.dateType,
                })
              );
            }}
            className="btn bg-gradient-secondary m-0 me-2"
          >
            Reset
            <i className="material-icons opacity-10">settings_backup_restore</i>
          </button>
          <button
            type="button"
            id="datepickerSumbit"
            onClick={() => {
              dispatch(setButtonClicked());
              dispatch(
                setTimeSeries({
                  start: moment(state[0].startDate).format("YYYY-MM-DD"),
                  end: moment(state[0].endDate).format("YYYY-MM-DD"),
                  dateType: resd?.timeSeries?.dateType,
                  buttonClicked: !resd?.timeSeries?.buttonClicked,
                })
              );
            }}
            className="btn bg-gradient-primary m-0"
          >
            Submit
            <i className="material-icons opacity-10">arrow_right_alt</i>
          </button>
        </div>
      </div>
    </>
  );
}
